<template>
  <div class="modal fade" id="app_info_modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="color: #9b9b9b;" id="exampleModalLongTitle">描述文件上传</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group row">
              <label for="inputEmail3" class="col-sm-2 col-form-label">ICON 图标</label>
              <div class="col-sm-10">
                <input @change="icon_change" type="file" class="form-control" id="icon_file">
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword3" class="col-sm-2 col-form-label">应用名</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" v-model="appName">
              </div>
            </div>
          </form>
          <div v-if="startUpload" class="progress">
            <div class="progress-bar progress-bar-striped" role="progressbar" :style="'width:'+progress"
              aria-valuemin="0" aria-valuemax="100">{{progress}}</div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="mobileConfigAppUpload" :disabled="startUpload" style="width: 30em;height: 3em;" type="button"
            class="btn btn-primary">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var self;
export default {
  props: ["mobileConfigFile"],
  mounted() {
    self = this;
    console.log(this.pkgInfo);
    this.$nextTick(() => {
      $("#app_info_modal").modal("show");
      $("#app_info_modal").on("hidden.bs.modal", function(e) {
        console.log("模态框消失");
        self.$emit("showModal", false);
      });
    });
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      appName: "",
      iconFile: null,
      progress: 0,
      startUpload: false
    };
  },
  methods: {
    icon_change: function(event) {
      var iconFile = event.target.files[0];
      this.iconFile = iconFile;
    },
    mobileConfigAppUpload: function() {
      var formData = new FormData();
      formData.append("appName", this.appName);
      formData.append("iconFile", this.iconFile);
      formData.append("mobileConfigFile", this.mobileConfigFile);
      formData.append("authToken", this.getToken());
      let requestConfig = {
        progress: progressEvent => {
          var complete =
            (((progressEvent.loaded / progressEvent.total) * 100) | 0) + "%";
          this.progress = complete;
          if (complete == "100%") {
            self.successToastr("文件上传成功，系统处理完成后自动关闭");
          }
        },
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.startUpload = true;
      this.progress = 0;
      this.$http
        .post(
          this._Global.HTTP_SERVER + "/auth/mobileconfig/app/upload",
          formData,
          requestConfig
        )
        .then(response => {
          console.log(response);
          $("#app_info_modal").modal("hide");
          this.$emit("showModal", false);
          window.location.reload();
        });
    }
  }
};
</script>

<style scoped>
#icon_file {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/MobielConfigAppWindow.vue